import { IState } from '../../../store';
import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export const selectAgent = (state: IState): IAgentSchema | null => state.offerData.agent;
